import { put } from 'redux-saga/effects';
import {
  videoAttachmentsFetchSuccessAction,
  videoAttachmentsFetchErrorAction,
} from 'components/video-box/video-attachments/actions';
import { fetchVideoAttachmentsApi } from '../../../common/api/videos';

export function* fetchVideoAttachmentsEffect({ payload }) {
  try {
    const response = yield fetchVideoAttachmentsApi(payload.videoId);
    yield put(videoAttachmentsFetchSuccessAction(response));
  } catch (error) {
    yield put(videoAttachmentsFetchErrorAction());
  }
}
